const common = {
  skipToContent: "Skip to content",
  
  navBarMenu: {
    home: "Home",
    services: "Services",
    expertise: {
      title: "Expertise",
      blog: "Blog",
      activities: "Activities",
      cases: "Case Studies"
    },
    work: {
      title: "Work",
      experience: "Experience",
      projects: "Projects",
      technologies: "Technologies"
    },
    contact: "Contact",
    booking: "Book a Meeting"
  },

  activities: {
    types: {
      conference: "Conference",
      meetup: "Meetup",
      training: "Training",
      publication: "Publication",
      podcast: "Podcast"
    }
  },

  footer: {
    text: "Let's work together today!",
    footerMenuTitle: "SiteMap",
    footerMenu: [
      "Home",
      "Services",
      "Labs",
      "Technologies",
      "Experience",
      "Projects",
      "Contact"
    ],
    cta: {
      titlePrefix: "Let's ",
      titleHighlightCollaborate: "collaborate",
      titleMiddle: " and build something ",
      titleHighlightAmazing: "amazing",
      titleSuffix: " together!",
      description: "Specialized in production-ready AI solutions and scalable web architectures."
    },
    contactLocation: "Ile-De-France / Remote",
    admin: "Admin",
    legal: {
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    },
    copyright: "© {{year}} Alexandre SANOU. All rights reserved."
  },

  socials: {
    title: "Socials",
    github: "GitHub",
    linkedIn: "LinkedIn"
  },

  buttons: {
    send: "Send",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    back: "Back",
    demo: "Demo",
    download: "Download"
  },

  messages: {
    loading: "Loading...",
    error: "An error occurred",
    success: "Operation successful",
    noResults: "No results",
    confirmDelete: "Are you sure you want to delete?"
  }
};

export default common;
